import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@nuxtjs/composition-api';
import { computed } from 'vue';

interface Props {
  pageCount: number;
  currentPage?: number;
  marginPages?: number;
  pageRange?: number;
}
interface Item {
  index: number;
  breakView?: boolean;
  content?: number;
  selected?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiPagination',
  props: {
    pageCount: null,
    currentPage: { default: 1 },
    marginPages: { default: 1 },
    pageRange: { default: 3 }
  },
  setup(__props: any) {

const props = __props as { pageCount: number, currentPage: number, marginPages: number, pageRange: number };



const route = useRoute();
// TODO: Extract to separate file
const pages = computed(() => {
  const items: Item[] = [];
  const setPageItem = (index: number) => {
    const page = {
      index,
      content: index + 1,
      selected: index === props.currentPage - 1,
    };
    items[index] = page;
  };
  if (props.pageCount <= props.pageRange) {
    for (let i = 0; i < props.pageCount; i += 1) {
      setPageItem(i);
    }
  } else {
    const halfPageRange = Math.floor(props.pageRange / 2);
    const setBreakView = (index: number) => {
      const breakView = {
        index,
        disabled: true,
        breakView: true,
      };
      items[index] = breakView;
    };
    // 1st - loop thru low end of margin pages
    for (let i = 0; i < props.marginPages; i += 1) {
      setPageItem(i);
    }
    //   // 2nd - loop thru selected range
    let selectedRangeLow = 0;
    if (props.currentPage - halfPageRange > 0) {
      selectedRangeLow = props.currentPage - 1 - halfPageRange;
    }
    let selectedRangeHigh = selectedRangeLow + props.pageRange - 1;
    if (selectedRangeHigh >= props.pageCount) {
      selectedRangeHigh = props.pageCount - 1;
      selectedRangeLow = selectedRangeHigh - props.pageRange + 1;
    }
    for (
      let i = selectedRangeLow;
      i <= selectedRangeHigh && i <= props.pageCount - 1;
      i += 1
    ) {
      setPageItem(i);
    }
    // Check if there is breakView in the left of selected range
    if (selectedRangeLow > props.marginPages) {
      setBreakView(selectedRangeLow - 1);
    }
    // Check if there is breakView in the right of selected range
    if (selectedRangeHigh + 1 < props.pageCount - props.marginPages) {
      setBreakView(selectedRangeHigh + 1);
    }
    //   // 3rd - loop thru high end of margin pages
    for (
      let i = props.pageCount - 1;
      i >= props.pageCount - props.marginPages;
      i -= 1
    ) {
      setPageItem(i);
    }
  }
  return items;
});

return { __sfc: true,props, route, pages }
}

})